__turbopack_context__.v({
  "button": "AuthPromptModal-module__S3Qaba__button",
  "modal": "AuthPromptModal-module__S3Qaba__modal",
  "overlay": "AuthPromptModal-module__S3Qaba__overlay",
  "text": "AuthPromptModal-module__S3Qaba__text",
  "title": "AuthPromptModal-module__S3Qaba__title",
});
